import React, { useCallback, useEffect, useState } from 'react';
import styles from './BannerHalfWidthPointsSimpleVariants.module.scss';
import ImagePoints from '../../Components/ImageComponent/ImagePoints';
import { imageWrapperWithButtonRefFunction, sanitizeType } from '../../../../functions';
import ProductsCarousel from '../../../Products/ProductsCarousel';
import Lottie from 'lottie-react';
import TitleComponent from '../../Components/TitleComponent/TItleComponent';

const MaridekoBanner = ({ api, type }) => {
  return (
    <section id={api?.id} className={`${styles.BannerHalfWidthPointsSimpleVariants} ${styles.BannerMarideko} fullImageMeta  `}>
      <div className={`${styles.topContainer} ${sanitizeType(type, styles)}`}>
        <div className={styles.contentContainer}>
          <TitleComponent
            type="halfTitleSec marideko"
            properties={api.attributes}
            animationData={{
              animation: 'fade-right',
              // animationDelay: '300',
              animationDuration: '1000',
              animationEasing: 'easy-in-out',
            }}
          />
          {!!api?.attributes?.description && (
            <p className={styles.description} data-aos="fade-up" data-aos-duration="1000" data-aos-easing="easy-in-out" data-aos-once="false">
              {api.attributes.description}
            </p>
          )}
        </div>
        <div
          className={`${styles.imageContainer}`}
          data-aos="fade-up"
          // data-aos-delay="300"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          <div className={`${styles.imagePointsWrapper}`}>
            <ImagePoints properties={api.attributes} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MaridekoBanner;
